module.exports = __webpack_public_path__ + "media/flags/gl-95973d53.svg";